import { BaseVenetianBlinds } from '../constants/productTypes';
import { ProductBuilderMachineContext } from '../types';

export const isVenetianBlinds = ({
  products,
}: ProductBuilderMachineContext) => {
  const venetianBlindsTimberProductType: BaseVenetianBlinds = 'Venetian Timber';
  const venetianBlindsPvcProductType: BaseVenetianBlinds = 'Venetian PVC';
  const venetianBlindsAluminiumProductType: BaseVenetianBlinds =
    'Venetian Aluminium';
  return (
    products[0].type.includes(venetianBlindsTimberProductType) ||
    products[0].type.includes(venetianBlindsPvcProductType) ||
    products[0].type.includes(venetianBlindsAluminiumProductType)
  );
};
